<template>
    <v-list-item>
        <v-list-item-title>{{ $t(translation + (dataKey?"."+dataKey:"")) }}</v-list-item-title>
        <v-list-item-subtitle class="text-right">
          <slot name="header">{{ text?text:(data && dataKey?data[dataKey] : "") }}</slot>
        </v-list-item-subtitle>
      </v-list-item>
</template>

<script>

  export default {
    name: 'FCCProperty',
    props: {
      data: Object,
      dataKey: String,
      translation: String,
      text: String
    },
    components: {
    }
  }
</script>
<style scoped>
  .tag{
    width:130px;
    display:inline-block;
  }
  .v-list-item{
    padding: 0;
  }
  .v-list-item__title{
    font-size: 13px;
    max-width:130px;
  }
  .v-list-item__subtitle{
    text-align: left !important;
    white-space: initial;
  }
</style>